import React, { useEffect, useState } from "react";
import { fetchGifts } from "../services/GiftServices";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "./Gifting.css";

const WHATSAPP_PHONE = process.env.REACT_APP_WHATSAPP_PHONE || "919262718449";
function useQuery() {
  const { search } = useLocation();
  return Object.fromEntries(new URLSearchParams(search));
}

export default function GiftList() {
  const q = useQuery();
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const data = await fetchGifts({ occasion: q.occasion, q: q.q });
        setItems(data || []);
      } finally { setLoading(false); }
    })();
  }, [q.occasion, q.q]);

  const handleWhatsApp = (gift) => {
    const msg = encodeURIComponent(
      `Hi, I want to customize the gift "${gift?.name}". Please assist me.`
    );
    window.open(`https://wa.me/${WHATSAPP_PHONE}?text=${msg}`, "_blank");
  };

  return (
    <div className="gift-list-page">
      <header className="gift-list-header">
        <h2>{q.occasion ? `${q.occasion[0].toUpperCase()+q.occasion.slice(1)} Gifts` : "All Gifts"}</h2>
      </header>

      {loading ? <div className="loading">Loading…</div> : (
        <div className="gift-grid">
          {items.map((g, i) => (
            <motion.div key={g.id} className="gift-card"
              initial={{ opacity: 0, y: 12 }} whileInView={{ opacity: 1, y:0 }} viewport={{ once:true }} transition={{ delay: i*0.05 }}
            >
              <Link to={`/gifts/${g.slug}`} className="img-wrap">
                <img  src={g.imageUrl} alt={g.name} loading="lazy" />
              </Link>
              <div className="meta">
                <h4>{g.name}</h4>
                <p className="price">
                  ₹{g.discountedPrice ? g.discountedPrice : Number(g.basePrice).toFixed(2)}
                  {g.discountPercent > 0 && (
                    <span style={{ color: "red", marginLeft: "8px", fontSize: "0.95em" }}>
                      <del>₹{Number(g.basePrice).toFixed(2)}</del> ({g.discountPercent}% OFF)
                    </span>
                  )}
                </p>
                <div className="tags">
                  {(g.tags || "").split(",").slice(0,3).map(t => <span className="tag" key={t}>{t.trim()}</span>)}
                </div>
                <Link className="btn" to={`/gifts/${g.slug}`}>Click for details</Link>
              </div>

              <button className="btn-contact "  onClick={() => handleWhatsApp(g)}>
                Need Customization? Contact Us
              </button>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
